/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { persistReducer } from 'redux-persist';
import localForage from 'localforage';
import { history } from '../utils';
import languageProviderReducer from '../components/LanguageProvider/reducer';
import globalReducer from '../appContainer/reducer';

const languagePersistConfig = {
  key: 'language',
  storage: localForage,
};

//
// const appReducer = combineReducers({
//   /* your app’s top-level reducers */
// })
//
// const rootReducer = (state, action) => {
//   return appReducer(state, action)
// }
/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */
export default function createReducer(injectedReducers = {}) {
  const rootReducer = combineReducers({
    global: globalReducer,
    language: persistReducer(languagePersistConfig, languageProviderReducer),
    router: connectRouter(history),
    ...injectedReducers,
  });

  return rootReducer;
}
